import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { useApiStore } from './store/useApiStore'
import { toast } from 'sonner'

/**
 * ApiErrorRegistrar – handles toasting API errors.
 *
 * @returns {JSX.Element}  The ApiErrorRegistrar component
 */
export default function ApiErrorRegistrar() {
  const setErrorHandler = useApiStore(s => s.setErrorHandler)
  const navigate = useNavigate()

  useEffect(() => {
    setErrorHandler((status, { message, details, description }) => {
      if (status === 404) {
        console.warn('[ApiErrorRegistrar] 404')
        navigate('/chat', { replace: true })
      }

      toast.error(
        `Error ${status}`,{
        description: description || details || message,
        duration: 8000,
      })
    })
  }, [setErrorHandler,  navigate])

  return null
}
